var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-wrapper ticket-wrapper ticket-manage-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "breadcrumbwrapper d-flex justify-content-between align-items-center gap-3 flex-wrap pb-2"
  }, [_c('breadcrumb', {
    attrs: {
      "items": _vm.breadcrumbItems
    }
  }), _c('button', {
    staticClass: "btn univ-btn btn-secondary mt-0 d-inline-flex align-items-center justify-content-center gap-2",
    on: {
      "click": function click($event) {
        return _vm.openModal(_vm.row, 'AddTicketModal');
      }
    }
  }, [_vm._m(0), _vm._v(" Add Ticket ")])], 1), _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-lg-3 col-sm-6 mb-3"
  }, [_c('div', {
    staticClass: "ticket_card total-issue-card d-flex align-items-center gap-3 h-100"
  }, [_c('div', {
    staticClass: "iconwrapper d-flex align-items-center justify-content-center flex-shrink-0"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "fill-rule": "evenodd",
      "d": "M20 4H4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1M4 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm2 5h2v2H6zm5 0a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zm-3 4H6v2h2zm2 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1m-2 3H6v2h2zm2 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }
  })])]), _c('div', {
    staticClass: "contentwrapper"
  }, [_c('div', {
    staticClass: "content-title"
  }, [_vm._v(" Total Issues ")]), _c('div', {
    staticClass: "issueCount clr-title fw-bold"
  }, [_vm._v(" " + _vm._s(_vm.stats.total_issues) + " ")])])])]), _c('div', {
    staticClass: "col-lg-3 col-sm-6 mb-3"
  }, [_c('div', {
    staticClass: "ticket_card active-issue-card d-flex align-items-center gap-3 h-100"
  }, [_c('div', {
    staticClass: "iconwrapper d-flex align-items-center justify-content-center flex-shrink-0"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"
    }
  }), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M5 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7.17a3.001 3.001 0 0 1 5.66 0H19a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-1.17a3.001 3.001 0 0 1-5.66 0zM2 7a3 3 0 0 1 3-3h8a1 1 0 0 1 1 1a1 1 0 1 0 2 0a1 1 0 0 1 1-1h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-2a1 1 0 0 1-1-1a1 1 0 1 0-2 0a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3zm13 2a1 1 0 0 1 1 1v.5a1 1 0 1 1-2 0V10a1 1 0 0 1 1-1m1 4.5a1 1 0 1 0-2 0v.5a1 1 0 1 0 2 0z"
    }
  })])])]), _c('div', {
    staticClass: "contentwrapper  "
  }, [_c('div', {
    staticClass: "content-title"
  }, [_vm._v(" Assigned Active Issues ")]), _c('div', {
    staticClass: "issueCount clr-title fw-bold"
  }, [_vm._v(" " + _vm._s(_vm.stats.open_issues) + " ")])])])]), _c('div', {
    staticClass: "col-lg-3 col-sm-6 mb-3"
  }, [_c('div', {
    staticClass: "ticket_card closed-issue-card d-flex align-items-center gap-3 h-100"
  }, [_c('div', {
    staticClass: "iconwrapper d-flex align-items-center justify-content-center flex-shrink-0"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 48 48"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "4"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linejoin": "round",
      "d": "M9 16L34 6l4 10M4 16h40v6c-3 0-6 2-6 5.5s3 6.5 6 6.5v6H4v-6c3 0 6-2 6-6s-3-6-6-6z"
    }
  }), _c('path', {
    attrs: {
      "d": "M17 25.385h6m-6 6h14"
    }
  })])])]), _c('div', {
    staticClass: "contentwrapper"
  }, [_c('div', {
    staticClass: "content-title"
  }, [_vm._v(" Assigned Closed Issues ")]), _c('div', {
    staticClass: "issueCount clr-title fw-bold"
  }, [_vm._v(" " + _vm._s(_vm.stats.closed_issues) + " ")])])])]), _c('div', {
    staticClass: "col-lg-3 col-sm-6 mb-3"
  }, [_c('div', {
    staticClass: "ticket_card open-issue-card d-flex align-items-center gap-3 h-100"
  }, [_c('div', {
    staticClass: "iconwrapper d-flex align-items-center justify-content-center flex-shrink-0"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "16",
      "viewBox": "0 0 640 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M144 160a80 80 0 1 0 0-160a80 80 0 1 0 0 160m368 0a80 80 0 1 0 0-160a80 80 0 1 0 0 160M0 298.7C0 310.4 9.6 320 21.3 320h214c-26.6-23.5-43.3-57.8-43.3-96c0-7.6.7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7h-42.7C47.8 192 0 239.8 0 298.7M320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96m65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.4C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7h300.6c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2l-.1-.2l-2.4-4.1l-.1-.2l-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5v-4.6l-2.7-1.5zM533.3 192h-42.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5.9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3.6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3.7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3l-2.9 1.7c-9.2 5.3-20.4 4-29.6-1.3s-16.1-14.5-16.1-25.1v-3.4c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4.5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v3.4c0 10.6-6.9 19.8-16.1 25.1s-20.4 6.6-29.6 1.3l-2.9-1.7c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8.5 14.3 6.8 17.9l2.9 1.7c9.2 5.3 13.7 15.8 13.7 26.4s-4.5 21.1-13.7 26.4l-3 1.7c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3l2.9-1.7c9.2-5.3 20.4-4 29.6 1.3s16.1 14.5 16.1 25.1v3.4c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9V492c0-10.6 6.9-19.8 16.1-25.1s20.4-6.6 29.6-1.3l2.9 1.7c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-3-1.7c-9.2-5.3-13.7-15.8-13.7-26.4s4.5-21.1 13.7-26.4l3-1.7zM472 384a40 40 0 1 1 80 0a40 40 0 1 1-80 0"
    }
  })])]), _c('div', {
    staticClass: "contentwrapper"
  }, [_c('div', {
    staticClass: "content-title"
  }, [_vm._v(" Created by Me ")]), _c('div', {
    staticClass: "issueCount clr-title fw-bold"
  }, [_vm._v(" " + _vm._s(_vm.stats.created_by_me) + " ")])])])])]), _c('div', {
    staticClass: "ticket-card p-3 mt-3 ticket-list-wrapper"
  }, [_c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-tabs', {
    attrs: {
      "card": ""
    },
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Assigned Tickets",
      "active": ""
    },
    on: {
      "click": function click($event) {
        _vm.tabIndex = 0;
      }
    }
  }, [_c('b-card-text', [_c('div', {
    staticClass: "filterwrapper d-flex align-items-center flex-wrap gap-3 mb-3"
  }, [_c('div', {
    staticClass: "search_input_wrapper position-relative"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: _vm.assignedSearchQuery,
      expression: "assignedSearchQuery",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control border-0 font-14 ",
    attrs: {
      "type": "text",
      "placeholder": "Enter Submitter Name"
    },
    domProps: {
      "value": _vm.assignedSearchQuery
    },
    on: {
      "change": function change($event) {
        _vm.assignedSearchQuery = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "iconwrapper position-absolute clr-bold-grey"
  }, [_c('i', {
    staticClass: "fa-solid fa-magnifying-glass cursor-pointer",
    on: {
      "click": _vm.getAssignedTickets
    }
  })])]), _c('b-dropdown', {
    staticClass: " filterdropdownwrapper",
    attrs: {
      "variant": "light",
      "menu-class": "w-100"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('span', {
          staticClass: "dropdownlabel clr-bold-grey fw-normal font-14 "
        }, [_c('span', {
          staticClass: "me-1"
        }, [_vm._v("Status:")]), _vm._v(" " + _vm._s(_vm.assignedSelectedStatus || 'Select'))])];
      },
      proxy: true
    }])
  }, _vm._l(_vm.statusOptions, function (status, index) {
    return _c('b-dropdown-item', {
      key: 'status-' + index + '-' + status,
      staticClass: "font-14",
      attrs: {
        "active": _vm.assignedSelectedStatus === status
      },
      on: {
        "click": function click($event) {
          _vm.assignedSelectedStatus = status;
        }
      }
    }, [_vm._v(" " + _vm._s(status) + " ")]);
  }), 1), _c('b-dropdown', {
    staticClass: " filterdropdownwrapper",
    attrs: {
      "variant": "light",
      "menu-class": "w-150 scrollable-menu"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('span', {
          staticClass: "dropdownlabel clr-bold-grey fw-normal font-14 "
        }, [_c('span', [_vm._v("Category:")]), _vm._v(" " + _vm._s(_vm.assignedSelectedCategory || 'Select'))])];
      },
      proxy: true
    }])
  }, _vm._l(_vm.categoryOptions, function (category, index) {
    return _c('b-dropdown-item', {
      key: 'category-' + index + '-' + category,
      staticClass: "font-14",
      attrs: {
        "active": _vm.assignedSelectedCategory === category
      },
      on: {
        "click": function click($event) {
          _vm.assignedSelectedCategory = category;
        }
      }
    }, [_vm._v(" " + _vm._s(category) + " ")]);
  }), 1)], 1), _c('div', {
    staticClass: "py-1 pagination-container flex-wrap gap-2"
  }, [_c('div', {
    staticClass: "pagination-info"
  }, [_vm._v(" Showing " + _vm._s(_vm.ticketData.from) + " to " + _vm._s(_vm.ticketData.to) + " of " + _vm._s(_vm.ticketData.total) + " results ")]), _c('div', {
    staticClass: "pagination-controls"
  }, [_c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "disabled": !_vm.ticketData.prev_page_url
    },
    on: {
      "click": function click($event) {
        return _vm.changeAssignedPage('first');
      }
    }
  }, [_vm._v("First")]), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "disabled": !_vm.ticketData.prev_page_url
    },
    on: {
      "click": function click($event) {
        return _vm.changeAssignedPage('prev');
      }
    }
  }, [_vm._v("Prev")]), _vm._l(_vm.pageNumbers, function (page) {
    return _c('span', {
      key: page,
      staticClass: "btn btn-link",
      class: {
        'active': page === _vm.assignedCurrentPage
      },
      on: {
        "click": function click($event) {
          return _vm.changeAssignedPage(page);
        }
      }
    }, [_vm._v(_vm._s(page))]);
  }), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "disabled": !_vm.ticketData.next_page_url
    },
    on: {
      "click": function click($event) {
        return _vm.changeAssignedPage('next');
      }
    }
  }, [_vm._v("Next")]), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "disabled": !_vm.ticketData.next_page_url
    },
    on: {
      "click": function click($event) {
        return _vm.changeAssignedPage('last');
      }
    }
  }, [_vm._v("Last")])], 2)]), _c('div', {
    staticClass: "table-responsive clientsData-wrap mt-4"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(" Issue Details ")]), _c('th', [_vm._v(" Submitter Details ")]), _c('th', [_vm._v(" Comments ")]), _c('th', [_vm._v(" Status ")]), _c('th', [_vm._v(" Action ")])])]), _vm.tickets && _vm.tickets.length > 0 ? _c('tbody', _vm._l(_vm.tickets.filter(function (t) {
    return t !== null;
  }), function (ticket, index) {
    return _c('tr', {
      key: "assigned-ticket-".concat((ticket === null || ticket === void 0 ? void 0 : ticket.id) || 'idx-' + index)
    }, [_c('td', [_c('div', {
      staticClass: "issue-category font-13 clr-black fw-semibold d-inline-flex align-items-center justify-content-center mb-2 badgecontainer"
    }, [_vm._v(" " + _vm._s(_vm.getCategoryName(ticket)) + " ")]), ticket ? _c('div', {
      staticClass: "issue-title clr-title"
    }, [_c('strong', [_vm._v("Title:")]), _vm._v(" " + _vm._s(ticket.title || 'No title available') + " ")]) : _vm._e()]), ticket ? _c('td', [_c('div', {
      staticClass: "submitter-name clr-title fw-semibold lh-base"
    }, [_vm._v(" " + _vm._s(_vm.getSubmitterName(ticket.submitter)) + " ")]), _c('div', {
      staticClass: "submitter-email clr-bold-grey lh-base"
    }, [_vm._v(" " + _vm._s(_vm.getSubmitterEmail(ticket.submitter)) + " ")])]) : _vm._e(), ticket ? _c('td', [_c('div', {
      staticClass: "comment-count fw-medium"
    }, [_vm._v(_vm._s(_vm.getCommentCount(ticket)))])]) : _vm._e(), ticket ? _c('td', [_c('div', {
      class: ['d-inline-flex align-items-center justify-content-center badgecontainer', _vm.getStatusClass(ticket.status)]
    }, [_c('span', {
      class: ['badge-dot', ticket.status === 1 ? 'open' : 'closed']
    }), _c('span', [_vm._v(_vm._s(_vm.getStatusText(ticket.status)))])])]) : _vm._e(), ticket ? _c('td', [_c('div', {
      staticClass: "action-icons"
    }, [_c('custom-route-button', {
      attrs: {
        "title": "View Details",
        "iconClass": "fas fa-eye",
        "routeLink": {
          name: 'TicketDetail',
          params: {
            ticketId: ticket.id
          }
        }
      }
    })], 1)]) : _vm._e()]);
  }), 0) : _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(" " + _vm._s(_vm.loading ? 'Loading tickets...' : 'No tickets found') + " ")])])])])])])], 1), _c('b-tab', {
    attrs: {
      "title": "Created by Me"
    },
    on: {
      "click": function click($event) {
        _vm.tabIndex = 1;
      }
    }
  }, [_c('div', {
    staticClass: "filterwrapper d-flex align-items-center flex-wrap gap-3 mb-3"
  }, [_c('b-dropdown', {
    staticClass: " filterdropdownwrapper",
    attrs: {
      "variant": "light",
      "menu-class": "w-100"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('span', {
          staticClass: "dropdownlabel clr-bold-grey fw-normal font-14 "
        }, [_c('span', {
          staticClass: "me-1"
        }, [_vm._v("Status:")]), _vm._v(" " + _vm._s(_vm.createdSelectedStatus || 'Select'))])];
      },
      proxy: true
    }])
  }, _vm._l(_vm.statusOptions, function (status, index) {
    return _c('b-dropdown-item', {
      key: 'created-status-' + index + '-' + status,
      staticClass: "font-14",
      attrs: {
        "active": _vm.createdSelectedStatus === status
      },
      on: {
        "click": function click($event) {
          _vm.createdSelectedStatus = status;
        }
      }
    }, [_vm._v(" " + _vm._s(status) + " ")]);
  }), 1), _c('b-dropdown', {
    staticClass: " filterdropdownwrapper",
    attrs: {
      "variant": "light",
      "menu-class": "w-100 scrollable-menu"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('span', {
          staticClass: "dropdownlabel clr-bold-grey fw-normal font-14 "
        }, [_c('span', [_vm._v("Category:")]), _vm._v(" " + _vm._s(_vm.createdSelectedCategory || 'Select'))])];
      },
      proxy: true
    }])
  }, _vm._l(_vm.categoryOptions, function (category, index) {
    return _c('b-dropdown-item', {
      key: 'created-category-' + index + '-' + category,
      staticClass: "font-14",
      attrs: {
        "active": _vm.createdSelectedCategory === category
      },
      on: {
        "click": function click($event) {
          _vm.createdSelectedCategory = category;
        }
      }
    }, [_vm._v(" " + _vm._s(category) + " ")]);
  }), 1)], 1), _c('div', {
    staticClass: "py-1 pagination-container flex-wrap gap-2"
  }, [_c('div', {
    staticClass: "pagination-info"
  }, [_vm._v(" Showing " + _vm._s(_vm.createdticketData.from) + " to " + _vm._s(_vm.createdticketData.to) + " of " + _vm._s(_vm.createdticketData.total) + " results ")]), _c('div', {
    staticClass: "pagination-controls"
  }, [_c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "disabled": !_vm.createdticketData.prev_page_url
    },
    on: {
      "click": function click($event) {
        return _vm.changeCreatedPage('first');
      }
    }
  }, [_vm._v("First")]), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "disabled": !_vm.createdticketData.prev_page_url
    },
    on: {
      "click": function click($event) {
        return _vm.changeCreatedPage('prev');
      }
    }
  }, [_vm._v("Prev")]), _vm._l(_vm.createdPageNumbers, function (page) {
    return _c('span', {
      key: page,
      staticClass: "btn btn-link",
      class: {
        'active': page === _vm.createdCurrentPage
      },
      on: {
        "click": function click($event) {
          return _vm.changeCreatedPage(page);
        }
      }
    }, [_vm._v(_vm._s(page))]);
  }), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "disabled": !_vm.createdticketData.next_page_url
    },
    on: {
      "click": function click($event) {
        return _vm.changeCreatedPage('next');
      }
    }
  }, [_vm._v("Next")]), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "disabled": !_vm.createdticketData.next_page_url
    },
    on: {
      "click": function click($event) {
        return _vm.changeCreatedPage('last');
      }
    }
  }, [_vm._v("Last")])], 2)]), _c('div', {
    staticClass: "table-responsive clientsData-wrap mt-4"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(" Issue Details ")]), _c('th', [_vm._v(" Submitter Details ")]), _c('th', [_vm._v(" Comments ")]), _c('th', [_vm._v(" Status ")]), _c('th', [_vm._v(" Action ")])])]), _vm.createdtickets && _vm.createdtickets.length > 0 ? _c('tbody', _vm._l(_vm.createdtickets, function (ticket, index) {
    var _vm$getSubmitterName, _vm$getSubmitterEmail, _vm$getCommentCount, _vm$getStatusText;

    return _c('tr', {
      key: "created-ticket-".concat((ticket === null || ticket === void 0 ? void 0 : ticket.id) || 'idx-' + index)
    }, [_c('td', [_c('div', {
      staticClass: "issue-category font-13 clr-black fw-semibold d-inline-flex align-items-center justify-content-center mb-2 badgecontainer"
    }, [_vm._v(" " + _vm._s(_vm.getCategoryName(ticket) ? _vm.getCategoryName(ticket) : 'Unknown') + " ")]), _c('div', {
      staticClass: "issue-title clr-title "
    }, [_c('strong', [_vm._v("Title:")]), _vm._v(" " + _vm._s(ticket.title || 'No title available'))])]), _c('td', [_c('div', {
      staticClass: "submitter-name clr-title fw-semibold lh-base"
    }, [_vm._v(" " + _vm._s((_vm$getSubmitterName = _vm.getSubmitterName(ticket.submitter)) !== null && _vm$getSubmitterName !== void 0 ? _vm$getSubmitterName : 'Unknown') + " ")]), _c('div', {
      staticClass: "submitter-email clr-bold-grey lh-base"
    }, [_vm._v(" " + _vm._s((_vm$getSubmitterEmail = _vm.getSubmitterEmail(ticket.submitter)) !== null && _vm$getSubmitterEmail !== void 0 ? _vm$getSubmitterEmail : 'Unknown') + " ")])]), _c('td', [_c('div', {
      staticClass: "comment-count fw-medium"
    }, [_vm._v(_vm._s((_vm$getCommentCount = _vm.getCommentCount(ticket)) !== null && _vm$getCommentCount !== void 0 ? _vm$getCommentCount : '0'))])]), _c('td', [_c('div', {
      class: ['d-inline-flex align-items-center justify-content-center badgecontainer', _vm.getStatusClass(ticket.status)]
    }, [_c('span', {
      class: ['badge-dot', ticket.status === 1 ? 'open' : 'closed']
    }), _c('span', [_vm._v(_vm._s((_vm$getStatusText = _vm.getStatusText(ticket.status)) !== null && _vm$getStatusText !== void 0 ? _vm$getStatusText : 'Unknown'))])])]), _c('td', [_c('div', {
      staticClass: "action-icons"
    }, [ticket ? _c('custom-route-button', {
      attrs: {
        "title": "View Details",
        "iconClass": "fas fa-eye",
        "routeLink": {
          name: 'TicketDetail',
          params: {
            ticketId: ticket.id
          }
        }
      }
    }) : _vm._e()], 1)])]);
  }), 0) : _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(" " + _vm._s(_vm.createdLoading ? 'Loading tickets...' : 'No tickets found') + " ")])])])])])])], 1)], 1)], 1)]), _c('AddTicketModal', {
    attrs: {
      "id": "AddTicketModal",
      "member": _vm.row,
      "categories": _vm.categories
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      },
      "onSuccess": _vm.reloadPage
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('i', {
    staticClass: "fas fa-add"
  })]);
}]

export { render, staticRenderFns }